<!--
 * @Description: 加入产品申请审批
 * @Author: Xiaochun liu
 * @Date: 2024-04-12 16:47:29
 * @LastEditors: Lxc 1533761120@qq.com
 * @LastEditTime: 2024-04-29 16:02:42
-->
<script setup lang="ts">
import { useMessage } from 'naive-ui'
import { Close } from '@vicons/carbon'
import { archiveReviewHasPermissions } from '@/api/message-notify'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
})
const emits = defineEmits(['update:modelValue', 'updateHandle'])

const message = useMessage()

const manageValue = ref(2)

const showModal = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emits('update:modelValue', value)
  },
})

function closeHandle() {
  showModal.value = false
}

function submitHandle() {
  archiveReviewHasPermissions({
    applyId: props.data.applyId,
    archiveId: props.data.archiveId,
    code: 1,
    enterpriseId: props.data.enterpriseId,
    memberId: props.data.userId,
    role: manageValue.value,
  }).then((res) => {
    window.$message?.success(`你通过了${props.data.nickName}的加入申请`)
    closeHandle()
    emits('updateHandle')
  }).catch((error) => {
    message.error(error.resultMsg)
  })
}
</script>

<template>
  <NModal v-model:show="showModal">
    <div class="apply-for-product-dialog">
      <div class="dialog-header flex items-center justify-between">
        <div class="header-title">
          <div class="title">
            加入产品申请审批
          </div>
          <div class="sub-title">
            请给<span class="high-text">{{ data.nickName }}</span>分配产品管理权限
          </div>
        </div>
        <button class="close-btn" :data-ph-capture-attribute-page-actions="$getPosthogPath(['通过', '加入产品申请审批', '取消'])"
          @click="closeHandle">
          <NIcon :size="20" :component="Close" />
        </button>
      </div>
      <div class="dialog-body">
        <div class="manage-tip">
          只有分配权限并且点击下方“确定”按钮之后才会成功通过申请
        </div>
        <div class="manage-wrap">
          <div class="authority-title">
            管理权限
          </div>
          <NRadioGroup v-model:value="manageValue" name="radiogroup">
            <NSpace>
              <NRadio :value="2">
                普通成员
              </NRadio>
              <NRadio :value="1">
                编辑成员
              </NRadio>
            </NSpace>
          </NRadioGroup>
        </div>
        <div class="manage-content">
          <div>普通成员：只能查看产品详情</div>
          <div>编辑成员：可以对产品的方案、提案验证报告进行编辑、更新，可以添加竞品等</div>
        </div>
      </div>
      <div class="dialog-footer flex justify-end">
        <button class="button-gradient submit-btn"
          :data-ph-capture-attribute-page-actions="$getPosthogPath(['通过', '加入产品申请审批', '确定'])" @click="submitHandle">
          确定
        </button>
      </div>
    </div>
  </NModal>
</template>

<style lang="scss" scoped>
.apply-for-product-dialog {
  width: 500px;
  height: 351px;
  padding: 24px;
  background: #FFFFFF;
  border-radius: 8px;

  .dialog-header {
    position: relative;
    margin-bottom: 8px;

    .header-title {
      .title {
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        color: #242F57;
        line-height: 22px;
      }

      .sub-title {
        font-size: 12px;
        color: #425466;
        line-height: 20px;

        .high-text {
          color: #FF4080;
        }
      }
    }

    .close-btn {
      position: absolute;
      top: -8px;
      right: -8px;
      z-index: 1;
    }
  }

  .dialog-body {
    .manage-tip {
      width: 100%;
      padding: 8px 12px;
      margin-bottom: 12px;
      background: rgba(255, 250, 232, 0.91);
      border-radius: 4px;
      font-size: 12px;
      color: #C8831D;
      line-height: 20px;
    }

    .authority-title {
      margin-bottom: 14px;
      font-weight: 500;
      font-size: 14px;
      color: #242F57;
      line-height: 23px;
    }

    .manage-wrap {
      margin-bottom: 21px;

      :deep(.n-radio) {
        --n-dot-color-active: #FF4080 !important;
        --n-box-shadow-active: inset 0 0 0 1px #FF4080 !important;
        --n-box-shadow-focus: inset 0 0 0 1px #FF4080, 0 0 0 2px rgba(255, 64, 128, 0.2) !important;
        --n-box-shadow-hover: inset 0 0 0 1px #FF4080 !important;
      }
    }

    .manage-content {
      width: 100%;
      padding: 12px;
      margin-bottom: 20px;
      background: rgba(249, 250, 251, 0.91);
      border-radius: 4px;
      border: 1px solid #E6E6E6;
      font-size: 12px;
      color: #425466;
      line-height: 20px;
    }
  }

  .dialog-footer {
    .submit-btn {
      width: 92px;
      height: 32px;
      font-size: 14px;
    }
  }
}
</style>
